/* eslint-disable import/prefer-default-export */
export enum ScenarioTypes {
  snapshot = 'SINGLE_POINT',
  timeseries = 'MULTIPLE_POINT',
}
